import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace',
  standalone: false,
  pure: true,
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, ...args: string[]): string {
    if (args.length === 0) {
      return value;
    }

    return value.replaceAll(args[0], args[1]);
  }
}
